import {
    CellRenderContext,
    IMeasureBag,
    IMutableGridModel
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {CellPopupView} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/CellPopupView';
import {FrameCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/frame/FrameCell';
import {GridModels} from '@mintdata-wsp/wsp/ui/components/grid/GridModels';
import {BaseComponentWithContext} from '@mintdata/mint-kit/api/components/BaseComponentWithContext';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {Popover} from '@mintdata/mint-kit/impl/components/popover/Popover';
import {IPopupManager, PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./CellView.less');
const cx = classnames.bind(styles);

export interface CellViewProps
{
    ctx:CellRenderContext;
}

@observer
export class CellView extends BaseComponentWithContext<CellViewProps, any> //React.Component<CellViewProps, any>
{
    private _popupId:GUID = IdUtil.newGUID();
    private _gridModel:IMutableGridModel = null;

    private _cellBodyRef:HTMLElement;

    @observable
    private _isMouseOver:boolean = null;

    constructor(props:CellViewProps,context:any)
    {
        super(props, context);
        this._init();
    }

    @bind
    private _onCellBodyRef(ref:HTMLElement)
    {
        this._cellBodyRef = ref;
    }

    componentDidMount(): void
    {
        if( this.props.ctx.ref )
            this.props.ctx.ref(this._cellBodyRef);
    }

    componentWillReceiveProps(nextProps:Readonly<CellViewProps>, nextContext:any):void
    {
        this._init();
    }

    @bind
    private _init():void
    {
        if( this._isFrame() )
        {
            const cellValue = this._getCellValue();
            this._gridModel = GridModels.forExistingFrame(cellValue as IFrame);
            this._gridModel.getAppearance().hasBorder = false;

            // controllers.ui.gridMeasure.measure(new GridMeasureRequest(
            //                                      this._gridModel,
            //                                      this._gridModel.getBodyWithBothHeaders(),
            //                                      2,
            //                                      this._gridModel.getBodyWithBothHeaders().getNumColumns(),
            //                                      5,
            //                                      5,
            //                                      this._onMeasureDone
            //                                    ));

        }
    }

    @bind
    private _getOrCreatePopupId()
    {
        return this._popupId;
    }

    @action.bound
    _onMouseEnter()
    {
        this._isMouseOver = true;
    }

    @action.bound
    _onMouseLeave()
    {
        this._isMouseOver = false;
    }

    @bind
    private _onPopupRef()
    {
        return (ref:HTMLElement):void=>
        {
            if (!ref)
                return;

            this._cellBodyRef = ref;

            const popupManager: IPopupManager = this.context.popupManager;
            const popupId = this._getOrCreatePopupId();

            const popupFn: any = popupManager.position(popupId, SourceAnchor.CenterTop, PopupAnchor.CenterBottom);
            popupFn(ref);
        }
    }

    @bind
    private _renderPopup()
    {
        const popupId = this._getOrCreatePopupId();

        const bodyWithBothHeaders = this._gridModel.getBodyWithBothHeaders();
        const totalWidth = bodyWithBothHeaders.getAllColumnsWidth();
        const totalHeight = bodyWithBothHeaders.getAllRowsHeight();

        return  <Popover id={popupId} isModal={false}>
                {
                    this._isMouseOver?
                        <CellPopupView gridModel={this._gridModel} width={totalWidth} height={totalHeight}/>
                        :
                        null
                }
                </Popover>
    }

    @bind
    private _onMeasureDone(bag:IMeasureBag)
    {
        this._updateGridModelSizes(bag);
    }

    @bind
    private _updateGridModelSizes(bag:IMeasureBag)
    {
        const gridModel = this._gridModel;
        const view = gridModel.getBodyWithBothHeaders();
        for (let colIndex = 0; colIndex < bag.getNumColumns(); colIndex++)
        {
            let widestColumn = bag.getWidestColumn(colIndex);
            view.setColumnWidth(colIndex, widestColumn);
        }
    }

    // @bind
    // private _renderGridMeasurer()
    // {
    //     return  <GridMeasureView isVisible={false}
    //                               gridModel={this._gridModel}
    //                               viewToMeasure={this._gridModel.getBodyWithBothHeaders()}
    //                               numRowsToMeasure={2}
    //                               numColumnsToMeasure={this._gridModel.getBodyWithBothHeaders().getNumColumns()}
    //                               horizontalCellPadding={7}
    //                               verticalCellPadding={5}
    //                               onMeasureDone={this._onMeasureDone}
    //             />;
    // }

    @bind
    private _renderFrame()
    {
        const {ctx} = this.props;
        const aCell = ctx.cell as FrameCell;
        const displayString = aCell.toDisplayString();

        return  <div key={ctx.key}
                     style={ctx.style}
                     className={cx(ctx.className, 'frameCell')}
                     ref={this._onPopupRef()}
                     onMouseEnter={this._onMouseEnter}
                     onMouseLeave={this._onMouseLeave}
                >
                    <div className={cx('cellContent')}>
                        {displayString}
                    </div>
                    {this._renderPopup()}
                    {/*{this._renderGridMeasurer()}*/}

                </div>;
    }

    @bind
    private _renderNormal()
    {
        const {ctx} = this.props;
        const aCell = ctx.cell as FrameCell;
        const displayString = aCell.toDisplayString();

        return  <div key={ctx.key}
                     style={ctx.style}
                     className={cx(ctx.className, 'frameCell')}
                     ref={this._onCellBodyRef}
                >
                    <div className={cx('cellContent')}>
                        {displayString}
                    </div>
                </div>;
    }

    @bind
    private _getCellValue():IValue
    {
        const {ctx} = this.props;
        const aCell = ctx.cell as FrameCell;

        return aCell.value;
    }

    @bind
    private _isFrame():boolean
    {
        const cellValue = this._getCellValue();
        return Type.Frame.isEqualTo(cellValue.getType());
    }

    render():React.ReactElement<any>
    {
        const isFrame = this._isFrame();
        if( isFrame )
            return this._renderFrame();
        else
            return this._renderNormal();
    }
}
